import { Divider, Typography } from "@mui/material";
import React from "react";
import QuestionsAndOptions from "../questionsAndOptions/QuestionsAndOptions";
import useAnswerStyle from './answersStyle';  

function Answers({ examResultData }) {
  const classes = useAnswerStyle();   

  return (
    <div className={classes.container}>
      <div className={classes.headingMain}>
        <Typography variant="h3">Your Answers</Typography>
        <Divider className={classes.divider} />
      </div>
      <QuestionsAndOptions examResultData={examResultData} />
    </div>
  );
}

export default Answers;
